'use client';

import { useMemo } from 'react';

//* Components
import Page from '@/components/common/Page';
import Text from '@/components/common/Text';
import Editor from '@/components/common/Editor';
import Container from '@/components/common/Container';

//* Style
import LegalTemplateStyle from 'styles/pages/LegalTemplateStyle';

const LegalTemplate = ({ pageData, className }) => {
	const storePrivacy = useMemo(() => {
		return pageData?.rows?.map((privacy, index) => {
			return (
				<div
					key={index}
					className='privacy'>
					<Text
						className={'h1 font-futura-medium privacy-title'}
						text={privacy.title}
					/>

					<Editor data={privacy.description} />
				</div>
			);
		});
	}, [pageData]);

	return (
		<Page className={className}>
			<LegalTemplateStyle>
				<Container section>
					<div className='privacies-wrap'>{storePrivacy}</div>
				</Container>
			</LegalTemplateStyle>
		</Page>
	);
};

export default LegalTemplate;
